export default __webpack_public_path__ + "img/19.41c4b61d.jpg";